import React from 'react';
import PropTypes from 'prop-types';

import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import LinearProgress from '@material-ui/core/LinearProgress';
import TextField from '@material-ui/core/TextField';

import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';
import AssessmentIcon from '@material-ui/icons/Assessment';

import DataTableToolbar from '../_Shared/DataTables/DataToolbar';
import DataTable from '../_Shared/DataTables/DataTable';
import CreateModal from '../_Shared/CreateModal';
import AppContent from '../_Shared/Layout/AppContent';

import Select from '../_Shared/SearchableDropdown';

const defaultUser = { emailAddress: '', name: '', role: 'Reporting_User' };
const systemGroups = [
    { label: "Reporting User", value: "Reporting_User" },
    { label: "Campaign Management", value: "Campaign_Management" },
    { label: "Data Analyst", value: "Data_Analyst" },
    { label: "Data Engineer", value: "Data_Engineer" },
    { label: "System Admin", value: "System_Admin" },
    { label: "System Developer", value: "System_Developer" }
];

class UserList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            showCreateModal: false,
            user: defaultUser,
            anchorEl: null,
            lockemailAddress: false
        }
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    toggleRowMenu = currentTarget => {
        this.setState((prevState) => {
            return { anchorEl: prevState.anchorEl === currentTarget ? null : currentTarget }
        })
    }

    closeToggleRowMenu = () => {
        this.setState({ anchorEl: null });
    }

    toggleCreateModal = e => {
        const { showCreateModal } = this.state;
        this.setState({ showCreateModal: !showCreateModal, user: defaultUser });
    }

    selectElement = user => {
        this.setState({ user });
    }

    handleEmailAddress = event => {
        const emailAddress = event.target.value;
        const { lockemailAddress } = this.state;
        const fullNameVal = this.fullName(emailAddress);
        this.handleInputChange('emailAddress', emailAddress.toLowerCase());
        if (lockemailAddress !== true && fullNameVal) {
            this.handleInputChange('name', fullNameVal);
        }
    }

    handleInputChange = (name, value, lockemailAddress) => {
        this.setState((prevState, state) => {
            return {
                user: Object.assign({}, prevState.user, { [name]: value, }),
                lockemailAddress: prevState.lockemailAddress === true || lockemailAddress === true
            }
        });
    }

    fullName = emailAddress => {
        let name = emailAddress.split('@')[0];
        if (name.indexOf('.') > -1) {
            let parts = name.split('.');
            return parts[0].charAt(0).toUpperCase()
                + parts[0].substr(1).toLowerCase()
                + ' ' + parts[1].charAt(0).toUpperCase()
                + parts[1].substr(1).toLowerCase();
        }
        return ''
    }

    createUser = e => {
        const { user } = this.state;
        this.props.onUserAdded(user);
        this.setState({ showCreateModal: false });
    }

    deleteUser = event => {
        const { user } = this.state;
        this.props.onUserRemoved(user);
        this.setState({ user: defaultUser, anchorEl: null });
    }

    render() {
        const { users, onEdit, loading, organisations } = this.props;
        const { showCreateModal, user, anchorEl } = this.state;
        return (<AppContent>
            {
                loading && <LinearProgress variant="query" />
            }
            <DataTableToolbar title="Users" numSelected={0} >
                <Tooltip title="Add New">
                    <IconButton onClick={this.toggleCreateModal} color="secondary"><AddCircleIcon /></IconButton>
                </Tooltip>
            </DataTableToolbar>
            {
                users &&
                <DataTable columns={[{ label: 'Email', field: 'emailAddress' }, { label: 'Status', field: 'status' }]} anchorEl={anchorEl} rows={users}
                    toggleRowMenu={this.toggleRowMenu} onElementSelect={this.selectElement} onCloseToggleRowMenu={this.closeToggleRowMenu}>
                    <MenuItem onClick={() => onEdit(`/organisations/users/${user.id}/manage/settings`, user)}>
                        <ListItemIcon><EditIcon /></ListItemIcon>
                        <ListItemText inset primary="Settings" />
                    </MenuItem>
                    <MenuItem onClick={() => onEdit(`/organisations/users/${user.id}/manage/reports`, user)}>
                        <ListItemIcon><AssessmentIcon /></ListItemIcon>
                        <ListItemText inset primary="Reports" />
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={this.deleteUser}>
                        <ListItemIcon><DeleteForeverIcon /></ListItemIcon>
                        <ListItemText inset primary="Delete" />
                    </MenuItem>
                </DataTable>
            }
            <CreateModal title="Create User" open={showCreateModal} closeHandler={this.toggleCreateModal} saveHandler={this.createUser}>
                <TextField margin="normal" autoFocus value={user.emailAddress} onChange={this.handleEmailAddress} id="emailAddress" name="emailAddress" label="Email Address" type="text" fullWidth />
                <TextField margin="normal" value={user.name} onChange={e => this.handleInputChange('name', e.target.value, true)} id="name" name="name" label="Full Name" type="text" fullWidth />
                <Select options={systemGroups} margin="normal" value={user.role} name="role" label="Role" onChange={value => this.handleInputChange('role', value)} placeholder={"Please select a role"} />
                <Select options={organisations} margin="normal" value={user.role} name="organisation" label="Organisation" onChange={value => this.handleInputChange('organisation', value)} placeholder={"Please select an organistation"} />
            </CreateModal>
        </AppContent>)
    }
}

UserList.propTypes = {
    users: PropTypes.array.isRequired,
};

export default UserList;


// WEBPACK FOOTER //
// ./src/Components/Presentation/Users/UserList.js